export default "__VITE_ASSET__cc2c94b1__"